/**
 * Returns the total price of all sub products
 *
 * @param {Option[]} options - An array of objects containing objects with a price.
 * @returns {number} The total price
 */
export const getSubProductsTotalPrice = (
	subProducts: Array<{
		label: string;
		price?: number;
		value?: string;
		href?: string;
	}>
): number =>
	subProducts.reduce((total, currentValue) => {
		if (currentValue.price) {
			return total + currentValue.price;
		}
		return total;
	}, 0);
